import { Pen, Section } from "./newSectionModalInterfaces";
import { CreatePanelLocation } from "../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/createLfSectionCall";

const dataIntegrity = (section: Section) => {
  const notNullPens = section.pens.filter((pen) => pen.penId !== null);
  const faultyData = notNullPens.filter((pen) => pen.io === null);
  if (faultyData.length > 0) {
    return false;
  }
  
  if (checkIOContent(notNullPens, "feederOutput", true)) {
    return false;
  }
  
  if (checkIOContent(notNullPens, "waterOutput", section.water)) {
    return false;
  }

  if (checkIOContent(notNullPens, "activatorInput", section.activator)) {
    return false;
  }

  return true;
} 

const checkIOContent = (pens: Pen[],  penKey: keyof Pen, ioContent?: boolean) => {
  if (ioContent) {
    return pens.filter((pen) => pen[penKey] === null || pen[penKey] === undefined).length > 0 ? true : false
  }
  return false;
}

const transformData = (section: Section): CreatePanelLocation[] => {
  return section.pens.filter((pen) => pen.penId!==null).map((pen) => {
    const waterTerminal = {device_id: pen.io ?? 0, terminal_type: pen.waterOutputConfig?.terminal_type_id, config: pen.waterOutputConfig, port: pen.waterOutput ?? 0};
    const activatorTerminal = {device_id: pen.io ?? 0, terminal_type: pen.activatorInputConfig?.terminal_type_id, config: pen.activatorInputConfig, port: pen.activatorInput ?? 0};
    const terminals = [{device_id: pen.io ?? 0, terminal_type: pen.feederOutputConfig?.terminal_type_id, config: pen.feederOutputConfig, port: pen.feederOutput ?? 0}] // TODO: Terminal types
    
    if (section.water) {
      terminals.push(waterTerminal);
    }

    if (section.activator) {
      terminals.push(activatorTerminal);
    }

    return {
      visual: pen.visual ?? "",
      location_name: pen.name ?? "",
      terminals: terminals
    }
  })
}

export const handleSectionLevel3Click = (section: Section, closeModal: () => void, confirmText: string, handleDataCallback: (section: CreatePanelLocation[], sectionName: string, panelSectionType: number) => void) => {
  if (!dataIntegrity(section)) {
    if (window.confirm(confirmText)) {
      closeModal();
      return;
    } 
    return;
  } 

  const transformedSection = transformData(section);
  handleDataCallback(transformedSection, section.name ?? "", section.columns);
  closeModal();
}